<template>
  	<v-container grid-list-xl fluid class="pb-15">
		<v-layout row wrap>
			<v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
						<v-list-item-content class="green2">
							<v-list-item-title class="green2">
							{{$t('farm.farmAddress')}}
							<v-tooltip top color="black">
								<template v-slot:activator="{ on, attrs }">
								<v-icon v-bind="attrs" v-on="on">
									mdi-help-circle-outline
								</v-icon>
								</template>
								<span>{{$t('farm.farmStateInfo')}}</span>
							</v-tooltip></v-list-item-title
							>
							<h5 class="mt-2 text-capitalize">
								{{ farm.address || "N/A" }}
							</h5>
						</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
			<v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
						<v-list-item-content class="green2">
							<v-list-item-title class="green2">
							{{$t('farm.country')}}
							<v-tooltip top color="black">
								<template v-slot:activator="{ on, attrs }">
								<v-icon v-bind="attrs" v-on="on">
									mdi-help-circle-outline
								</v-icon>
								</template>
								<span>{{$t('farm.countryState')}}</span>
							</v-tooltip></v-list-item-title
							>
							<h5 class="mt-2 text-capitalize">
								{{ farm.country || "N/A" }}
							</h5>
						</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
			<v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('Province/State')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
											<v-icon v-bind="attrs" v-on="on">
												mdi-help-circle-outline
											</v-icon>
										</template>
										<span>{{$t('farm.stateStatement')}}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.state || "N/A" }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
			<v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('Village/Town/City')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
										<v-icon v-bind="attrs" v-on="on">
											mdi-help-circle-outline
										</v-icon>
										</template>
										<span>{{$t('farm.cityStatement')}}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.city || 'N/A' }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
			<v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
							<v-list-item-content class="green2">
								<v-list-item-title class="green2">
									{{$t('farm.postal')}}
									<v-tooltip top color="black">
										<template v-slot:activator="{ on, attrs }">
										<v-icon v-bind="attrs" v-on="on">
											mdi-help-circle-outline
										</v-icon>
										</template>
										<span>{{$t('farm.streetStatement')}}</span>
									</v-tooltip>
								</v-list-item-title>
								<h5 class="mt-2 text-capitalize">
									{{ farm.street || "N/A" }}
								</h5>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
				</v-flex>
				<v-flex
					xs6
					sm4
					md2
					xl2
					:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
					class="lg5-custom mb-5"
				>
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
						<v-list-item-content class="green2">
							<v-list-item-title class="green2">
								{{$t('farm.plotNumber')}}
								<v-tooltip right color="black">
									<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
										mdi-help-circle-outline
									</v-icon>
									</template>
									<span>The postal Number of farm similar to House number.</span>
								</v-tooltip>
							</v-list-item-title>
							<h5 class="mt-2 text-capitalize">
								{{ farm.farmNumber || "N/A" }}
							</h5>
						</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
      		</v-flex>
			  <v-flex
					xs6
					sm4
					md2
					xl2
					:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
					class="lg5-custom mb-5"
				>
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
						<v-list-item-content class="green2">
							<v-list-item-title class="green2">
								{{$t('Total Farm Size')}}
								<v-tooltip top color="black">
									<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
										mdi-help-circle-outline
									</v-icon>
									</template>
									<span>{{$t('Total Farm Size')}}</span>
								</v-tooltip>
							</v-list-item-title>
							<h5 class="mt-2 text-capitalize">
								{{ farm.area + ' ' + (farm.areaUomId == 1 ? 'Acre' : 'Hectare') }}
							</h5>
						</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
      		</v-flex>
			  <v-flex
					xs6
					sm4
					md2
					xl2
					:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
					class="lg5-custom mb-5"
				>
				<v-card class="green2" flat min-height="100">
					<!-- <v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon> -->
					<v-list dense class="mb-n3 green2">
						<v-list-item>
						<v-list-item-content class="green2">
							<v-list-item-title class="green2">
								{{$t('Farm Geofence')}}
								<v-tooltip top color="black">
									<template v-slot:activator="{ on, attrs }">
									<v-icon v-bind="attrs" v-on="on">
										mdi-help-circle-outline
									</v-icon>
									</template>
									<span>{{$t('Farm Geofence')}}</span>
								</v-tooltip>
							</v-list-item-title>
							<h5 class="mt-2 text-capitalize">
								{{ "Mapped" }}
							</h5>
						</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
      		</v-flex>
		</v-layout>
		<!-- <div class="text-h6">Farm Zone</div>
		<v-layout row wrap>
			<v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
					<v-list dense class="mb-n3 green2">
						<v-list-item>
						<v-list-item-content class="green2">
							<v-list-item-title class="green2">
							{{$t('6 hectares')}}
							<v-tooltip top color="black">
								<template v-slot:activator="{ on, attrs }">
								<v-icon v-bind="attrs" v-on="on">
									mdi-help-circle-outline
								</v-icon>
								</template>
								<span>{{$t('6 hectares')}}</span>
							</v-tooltip></v-list-item-title
							>
							<h5 class="mt-2 text-capitalize">
								{{ 'Top Zone' }}
							</h5>
						</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
			<v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
					<v-list dense class="mb-n3 green2">
						<v-list-item>
						<v-list-item-content class="green2">
							<v-list-item-title class="green2">
							{{$t('3 hectares')}}
							<v-tooltip top color="black">
								<template v-slot:activator="{ on, attrs }">
								<v-icon v-bind="attrs" v-on="on">
									mdi-help-circle-outline
								</v-icon>
								</template>
								<span>{{$t('3 hectares')}}</span>
							</v-tooltip></v-list-item-title
							>
							<h5 class="mt-2 text-capitalize">
								{{ 'Bottom Left Zone'}}
							</h5>
						</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
			<v-flex
				xs6
				sm4
				md2
				xl2
				:style="$vuetify.breakpoint.width <= 980 && { flexBasis: '50%' }"
				class="lg5-custom mb-5"
			>
				<v-card class="green2" flat min-height="100">
					<v-icon class="float-right mt-2 mr-2">mdi-dots-horizontal</v-icon>
					<v-list dense class="mb-n3 green2">
						<v-list-item>
						<v-list-item-content class="green2">
							<v-list-item-title class="green2">
							{{$t('3 hectares')}}
							<v-tooltip top color="black">
								<template v-slot:activator="{ on, attrs }">
								<v-icon v-bind="attrs" v-on="on">
									mdi-help-circle-outline
								</v-icon>
								</template>
								<span>{{$t('3 hectares')}}</span>
							</v-tooltip></v-list-item-title
							>
							<h5 class="mt-2 text-capitalize">
								{{ 'Bottom Left Zone'}}
							</h5>
						</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-flex>
		</v-layout> -->
		<v-btn
			color="primary"
			depressed
			outlined
			:disabled="!farm || (farm.coordinates && farm.coordinates.length < 3)"
			:to="{ name: 'EditPrimaryFarm', query: { viewGeofenceLocation: true }}"
		>
			{{$t('View Geofence Location')}}
		</v-btn>
  	</v-container>
</template>
<script>
// import { mapGetters } from "vuex";
export default {
  name: "Location",
  // mounted(){
  //   if(this.getfarm.country.name==null){

  //   }
  // },
  computed: {
    // ...mapGetters(["getfarm"]),
  },
  props: {
	  farm: {
		  require: true
	  }
  },
  data() {
    return {
      country: "xxxx",
      city: "xxxx",
      state: "xxxx",
    };
  },
};
</script>
<style lang="scss" scoped>
// .col{
//   width: 20%;
// max-width: 20%;
// flex-basis: 20%;
// }
.flex.lg5-custom {
  width: 20%;
  max-width: 80%;
  flex-basis: 20%;
}
// .v-list .v-list-item-content .h5 {
//   font-size: 7px;
//   color: grey;
// }
</style>